import { configureStore } from '@reduxjs/toolkit';
import { rtlReducer, sidebarReducer, themeReducer } from '../../redux/reducers';
import sessionReducer from '../../features/session/sessionSlice';

const store = configureStore({
  reducer: {
    theme: themeReducer,
    sidebar: sidebarReducer,
    rtl: rtlReducer,
    user: sessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
